<template>
  <b-form-select
      v-model="value"
      text-field="name"
      :options="slots"
      @change="onChange"
      class="border-0"
      :class="value === null ? 'text-secondary' : 'text-primary'"
  />
</template>

<script>

export default {
  name: 'SlotSelector',
  props: {
    slots: Array,
    dayOfWeek: Number,
  },
  watch: {
    dayOfWeek: {
      handler() {
        this.value = this.dayOfWeek != null ? this.dayOfWeek : null;
      },
    },
  },
  data() {
    return {
      value: this.dayOfWeek != null ? this.dayOfWeek : null,
    }
  },
  methods: {
    onChange: function (value) {
      this.$emit('change', value);
    },
  },
}
</script>
